import { render, staticRenderFns } from "./MdrlAddMain.vue?vue&type=template&id=40e0082c&scoped=true&"
import script from "./MdrlAddMain.vue?vue&type=script&lang=js&"
export * from "./MdrlAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MdrlAddMain.vue?vue&type=style&index=0&id=40e0082c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e0082c",
  null
  
)

export default component.exports